import { merchandiseOptionIssues } from './merchandiseOptions2'
import { isBlankSection } from './blankSections2'
import axios from 'axios'
import { minimumConfigurationKey, provisionalMinimums } from '@/builderMinimumProvisional'
import { withApiToken, quoteResponseError } from '@/orderQuoteV2'

export const MINIMUM_VERSION = 'builder-minimums-v1'

export function minimumColorRows (line) {
  const rows = []
  ;(line.colors || []).forEach((color, index) => {
    const reference = String(color.minimum_color_id || color.color_id || index)
    rows.push({ color, reference, parent_reference: '' })
    ;(color.inner_colors || []).forEach((inner, innerIndex) => {
      rows.push({ color: inner, reference: reference + ':inner:' + (inner.minimum_color_id || innerIndex), parent_reference: reference })
    })
  })
  return rows
}

export function minimumInputId (lineId, reference, sizeId) {
  return 'minimum_quantity_' + encodeURIComponent(lineId + ':' + reference + ':' + sizeId)
}

export function builderMinimumPayload (form, placementsForLine) {
  const items = []
  ;(form.sections || []).forEach(section => {
    ;(section.style_lines || []).forEach(line => {
      if (!(section.program_info && section.program_info.program_id && line.style_info && line.style_info.style_id)) return
      items.push({
        id: line.id, section_id: section.id, program_id: Number(section.program_info.program_id), style_id: Number(line.style_info.style_id),
        blank_order: isBlankSection(section), promotion_free_item: !!line.promotion_applied,
        colors: minimumColorRows(line).map(({ color, reference, parent_reference }) => ({
          reference, parent_reference, name: color.customer_color_name || color.color_name || color.color_code || 'Color',
          sizes: (color.sizes || []).map(size => ({
            size_id: Number(size.size_id), size_name: size.size_name || String(size.size_id), quantity: size.quantity === '' || size.quantity == null ? 0 : Number(size.quantity),
            minimum_adjustment: size.minimum_adjustment ? { from: size.minimum_adjustment.from, to: size.minimum_adjustment.to } : null
          }))
        })),
        locations: (isBlankSection(section) ? [] : placementsForLine(section, line)).filter(placement => placement.design_mode).map(placement => ({
          id: String(placement.bundle_placement_id || placement.id), technique_id: Number(placement.technique && placement.technique.technique_id || 0),
          location_id: Number(placement.location && placement.location.location_id || 0), artwork_mode: placement.requires_new_art ? 'new_design' : placement.design_mode,
          artwork_id: Number(placement.artwork && (placement.artwork.media_id || placement.artwork.id) || 0),
          ptl_identity: String(placement.ptl_identity || ''),
          color_type_reference: typeof placement.color_type === 'string' ? placement.color_type : '',
          color_type_id: Number(placement.color_type && (placement.color_type.color_type_id || placement.color_type.id) || 0)
        }))
      })
    })
  })
  return { items }
}

export function minimumRegistryRows (result, current, error) {
  if (!current) return [{
    requirementId: 'minimum-evaluation', code: 'minimum_evaluation', step: 3, entityType: 'order',
    target: 'builder_minimum_summary', action: 'refresh_minimums', actionLabel: error ? 'Retry Minimum Check' : 'Check Minimum Requirements',
    message: error || 'Checking minimums and quantity requirements…', blocking: true,
    state: 'pending', severity: 'info', contributesToIssueCount: false, blocksReview: true, blocksLeavingStep: true
  }]
  return result.requirements.map(row => ({
    requirementId: row.requirement_id, code: row.type, step: 3, entityType: 'style', entityId: row.style_line_id,
    sectionId: row.section_id, styleLineId: row.style_line_id, decorationId: row.decoration_id,
    target: 'style_colors_' + row.style_line_id,
    focusTarget: row.color_reference && row.size_id ? minimumInputId(row.style_line_id, row.color_reference, row.size_id) : '',
    colorReference: row.color_reference,
    action: 'open_color_editor', actionLabel: 'Fix Issue', message: row.label + (row.blocking ? ': ' + row.action : ''),
    blocking: row.blocking, blocksReview: row.blocking, blocksLeavingStep: row.blocking,
    state: row.blocking ? 'pending' : 'resolved', contributesToIssueCount: false, severity: 'info', minimum: row
  }))
}

export default {
  data () {
    return { minimumExpanded2: {}, minimumResult2: null, minimumResultFingerprint2: '', minimumError2: '', minimumTimer2: null, minimumRequest2: 0, minimumUpdating2: false, minimumSaving2: false, minimumSnapshotKey2: '', minimumSessionRevision2: 0 }
  },
  computed: {
    minimumPayload2 () {
      return builderMinimumPayload(this.form, (section, line) => this.isDesignFirst2()
        ? this.lineBundlePlacements2(section, line)
        : (section.decoration_sets || []).filter(set => (line.decoration_set_ids || []).includes(set.id)))
    },
    minimumFingerprint2 () { return JSON.stringify([this.minimumPayload2, this.minimumConfigurationKey2]) },
    minimumConfigurationKey2 () {
      const designs = (this.form.bundles || []).map(bundle => [bundle.id, (bundle.placements || []).map(placement => [placement.id, placement.design_mode, placement.requires_new_art, placement.artwork && (placement.artwork.media_id || placement.artwork.id), placement.technique && placement.technique.technique_id, placement.location && placement.location.location_id])])
      return minimumConfigurationKey(this.minimumPayload2, [this.minimumSessionRevision2, designs, this.form.customer_info && this.form.customer_info.customer_id, this.$store && this.$store.state.user])
    },
    minimumProvisional2 () { return this.minimumSnapshotKey2 === this.minimumConfigurationKey2 ? provisionalMinimums(this.minimumResult2, this.minimumPayload2) : null },
    minimumDisplayCurrent2 () { return this.minimumCurrent2 || !!this.minimumProvisional2 },
    minimumCurrent2 () { return !!this.minimumResult2 && this.minimumResultFingerprint2 === this.minimumFingerprint2 && !this.minimumError2 },
    minimumRows2 () { return this.workflowRequirements2().filter(row => row.minimum) }
  },
  watch: {
    minimumConfigurationKey2 () { this.minimumSnapshotKey2 = ''; this.queueMinimumCheck2() },
    workspaceLifecycle2 (value) { if (value === 'ready') this.queueMinimumCheck2() }
  },
  created () {
    this._minimumSessionToken2 = localStorage.getItem('api_token')
    this._minimumSessionListener2 = () => this.checkMinimumSession2()
    window.addEventListener('storage', this._minimumSessionListener2)
    window.addEventListener('focus', this._minimumSessionListener2)
  },
  beforeDestroy () {
    window.removeEventListener('storage', this._minimumSessionListener2)
    window.removeEventListener('focus', this._minimumSessionListener2)
    clearTimeout(this.minimumTimer2)
    this.minimumRequest2++
  },
  methods: {
    checkMinimumSession2 () {
      const token = localStorage.getItem('api_token')
      if (token !== this._minimumSessionToken2) {
        this._minimumSessionToken2 = token
        this.minimumSessionRevision2++
        this.minimumSnapshotKey2 = ''
        this.minimumResultFingerprint2 = ''
      }
    },
    minimumRequirementsForRegistry2 () {
      if (this.minimumCurrent2) return minimumRegistryRows(this.minimumResult2, true, this.minimumError2)
      const pending = minimumRegistryRows(null, false, this.minimumError2)
      return pending.concat(this.minimumProvisional2 ? minimumRegistryRows(this.minimumProvisional2, true, '') : [])
    },
    lineMinimumRows2 (line) {
      return this.minimumRows2.filter(row => (row.minimum.contributors || []).some(contributor => contributor.style_line_id === line.id))
    },
    minimumQuantityId2 (line, color, sizeName) {
      const row = minimumColorRows(line).find(row => row.color === color)
      const size = this.getColorSizeEntry2(color, sizeName)
      return row && size ? minimumInputId(line.id, row.reference, size.size_id) : ''
    },
    queueMinimumCheck2 () {
      if (this.workspaceLifecycle2 !== 'ready' || this.minimumSaving2) return
      clearTimeout(this.minimumTimer2)
      this.minimumTimer2 = setTimeout(() => this.refreshMinimums2(), 250)
    },
    refreshMinimums2 (normalize = false) {
      // Event arguments are not normalization flags.
      this.checkMinimumSession2()
      normalize = normalize === true
      const items = this.minimumPayload2 && this.minimumPayload2.items || []
      const upstreamPending = typeof this.isDesignFirst2 === 'function' && this.isDesignFirst2() && (this.form.sections || []).some(section => (section.style_lines || []).some(line => line.style_info && line.style_info.style_id && !line.blank_order && (line.style_authority_loading || line.style_authority_error || line.style_authority_invalid || (typeof this.lineConfigurationsResolved2 === 'function' && !this.lineConfigurationsResolved2(section, line)))))
      if (upstreamPending || (this.workspaceLifecycle2 && this.workspaceLifecycle2 !== 'ready') || items.some(item => !item.blank_order && item.locations.some(location => !location.technique_id || !location.location_id || !location.ptl_identity))) {
        this.minimumRequest2 += 1
        this.minimumResultFingerprint2 = ''
        this.minimumUpdating2 = false
        clearTimeout(this.minimumTimer2)
        return Promise.resolve(null)
      }
      clearTimeout(this.minimumTimer2)
      const key = this.minimumFingerprint2 + ':' + normalize
      if (this._minimumPending2 && this._minimumPending2.key === key) return this._minimumPending2.promise
      const promise = this.fetchMinimums2(normalize).finally(() => { if (this._minimumPending2 && this._minimumPending2.promise === promise) this._minimumPending2 = null })
      this._minimumPending2 = { key, promise }
      return promise
    },
    async fetchMinimums2 (normalize) {
      clearTimeout(this.minimumTimer2)
      const fingerprint = this.minimumFingerprint2
      const configurationKey = this.minimumConfigurationKey2
      const requestId = ++this.minimumRequest2
      this.minimumUpdating2 = true
      this.minimumError2 = ''
      try {
        const response = await axios.post(this.$apiAdress + '/api/orders/v2/minimum-requirements', Object.assign({}, this.minimumPayload2, { normalize_quantities: normalize }), withApiToken())
        this.checkMinimumSession2()
        const authorizationError = quoteResponseError(response)
        if (authorizationError) throw authorizationError
        if (requestId !== this.minimumRequest2 || fingerprint !== this.minimumFingerprint2) return null
        if (!response.data || response.data.version !== MINIMUM_VERSION || !Array.isArray(response.data.requirements) || !Array.isArray(response.data.normalizations) || !response.data.requirements.every(row => row && typeof row.requirement_id === 'string' && typeof row.blocking === 'boolean' && Number.isFinite(row.required_quantity) && (row.eligible_quantity === null || Number.isFinite(row.eligible_quantity)) && Number.isFinite(row.shortage) && Array.isArray(row.contributors))) throw new Error('Invalid minimum response')
        if (normalize) {
          if (!response.data.normalized_confirmation) throw new Error('Missing normalized confirmation')
          this.applyMinimumNormalizations2(response.data.normalizations)
          const normalizedFingerprint = this.minimumFingerprint2
          await this.$nextTick()
          if (normalizedFingerprint !== this.minimumFingerprint2) return null
          // Only our matching server normalizations may advance this confirmation.
          if (requestId !== this.minimumRequest2 || configurationKey !== this.minimumConfigurationKey2) return null
        }
        this.minimumResult2 = response.data
        this.minimumSnapshotKey2 = configurationKey
        this.minimumResultFingerprint2 = this.minimumFingerprint2
        return response.data
      } catch (error) {
        if (requestId === this.minimumRequest2 && fingerprint === this.minimumFingerprint2) this.minimumError2 = 'Minimum requirements could not be checked. Retry before continuing.'
        return null
      } finally {
        if (requestId === this.minimumRequest2) this.minimumUpdating2 = false
      }
    },
    applyMinimumNormalizations2 (changes) {
      let changed = false
      let applied = 0
      ;(this.form.sections || []).forEach(section => (section.style_lines || []).forEach(line => {
        ;(changes || []).filter(change => change.style_line_id === line.id).forEach(change => {
          const row = minimumColorRows(line).find(row => row.reference === change.color_reference)
          const size = row && row.color.sizes.find(size => Number(size.size_id) === change.size_id)
          if (!size || Number(size.quantity) !== change.from) return
          this.$set(size, 'minimum_adjustment', { from: change.from, to: change.to })
          size.quantity = change.to
          applied++
          changed = true
        })
        this.syncLineUnits2(line)
      }))
      if (applied !== (changes || []).length) throw new Error('Normalization target changed')
      if (changed) this.announceWorkflow2('Quantity adjusted to the Style minimum. See the quantity requirements summary for details.')
    },
    commitMinimumQuantity2 (line, color, sizeName, value) {
      this.checkMinimumSession2()
      this.setColorSizeQuantity2(line, color, sizeName, value)
    },
    normalizeMinimumQuantity2 (line, color, sizeName) {
      // Blur/change is a local commit; normalization is confirmed in the Save transaction.
      if (color) this.syncLineUnits2(line)
      return Promise.resolve(true)
    },
    saveMinimumColors2 () {
      if (this._minimumSave2) return this._minimumSave2
      this.minimumSaving2 = true
      const configurationAtStart = this.minimumConfigurationKey2
      const promise = this.saveMinimumTransaction2().finally(() => {
        this.minimumSaving2 = false
        if (configurationAtStart !== this.minimumConfigurationKey2) this.queueMinimumCheck2()
        if (this._minimumSave2 === promise) this._minimumSave2 = null
      })
      this._minimumSave2 = promise
      return promise
    },
    async saveMinimumTransaction2 () {
      const line = this.colorEditor.line
      const section = this.colorEditor.section
      if (!line || !section) return false
      const input = typeof document !== 'undefined' && document.activeElement
      minimumColorRows(line).forEach(({ color, reference }) => color.sizes.forEach(size => {
        if (input && input.id === minimumInputId(line.id, reference, size.size_id)) this.commitMinimumQuantity2(line, color, size.size_name, input.value)
      }))
      await this.$nextTick()
      if (merchandiseOptionIssues(line).length) return false
      const result = await this.refreshMinimums2(true)
      if (!result || !this.minimumCurrent2 || this.colorEditor.line !== line || !this.colorEditor.open) return false
      const issue = this.minimumRequirementsForRegistry2().find(row => row.minimum && row.blocking)
      if (issue) {
        this.colorEditor.error = issue.minimum.action || 'Quantity requirements need attention.'
        this.navigateBuilderIssue2(issue)
        return false
      }
      return this.saveColorModal2()
    },
    minimumInputNotice2 (line, color, sizeName) {
      const target = this.minimumQuantityId2(line, color, sizeName)
      const row = this.lineMinimumRows2(line).find(row => row.focusTarget === target && (row.minimum.blocking || row.minimum.status === 'adjusted'))
      return row ? { blocking: row.minimum.blocking, text: row.minimum.blocking ? row.minimum.label + ': ' + row.minimum.action : row.minimum.adjustment_reason } : null
    },
    readinessLabel2 () {
      if (this.canFinishWizard2()) return 'Ready for group review'
      if (this.workflowRequirements2().some(row => row.code === 'color_type_loading')) return 'Loading Color Types'
      if (!this.minimumCurrent2 && this.stylesStepComplete2()) return this.minimumError2 ? 'Minimum check needs attention' : 'Checking quantity requirements'
      const count = this.builderIssues2().length
      return count ? count + ' requirement' + (count === 1 ? '' : 's') + ' need attention' : 'Complete the required steps'
    }
  }
}
